import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { recipient } from '@alycecom/services';

export const oneTimeCodeVerificationSlice = createSlice({
  name: 'oneTimeCodeVerification' as const,
  initialState: {
    isCodeModalOpen: false,
  },
  reducers: {
    toggleModal: (state, { payload }: PayloadAction<boolean>) =>
      Object.assign(state, {
        isCodeModalOpen: payload,
      }),
  },
  extraReducers: builder =>
    builder
      .addMatcher(recipient.endpoints.sendVerificationEmail.matchFulfilled, state =>
        Object.assign(state, {
          isCodeModalOpen: true,
        }),
      )
      .addMatcher(recipient.endpoints.sendVerificationEmail.matchRejected, state =>
        Object.assign(state, {
          isCodeModalOpen: true,
        }),
      )
      .addMatcher(recipient.endpoints.checkVerificationCode.matchFulfilled, state =>
        Object.assign(state, {
          isCodeModalOpen: false,
        }),
      ),
});

export const { toggleModal } = oneTimeCodeVerificationSlice.actions;

export type TOneTimeCodeVerificationState = ReturnType<typeof oneTimeCodeVerificationSlice.getInitialState>;
